<div class="topBar mobile" [ngClass]="isMobileMenuOpen==true?'open-menu':'' ">
  <app-landing-mobile-menu (isOpenMenu)="isOpen($event)"></app-landing-mobile-menu>
</div>
<div class="topBar all">
  <app-topbar></app-topbar>
  <!-- background: transparent url("/assets/images/hero.png") 0% 0% no-repeat padding-box; -->
</div>
<div class="image-inside">
  <img class="landing-image desktop" src="/assets/images/hero.png">
  <img class="landing-image mobile" src="/assets/images/hero-mobile.png" />
  <div class="text">
    <div class="firstLine">{{'TEXT.SALES_TEXT' | translate}}</div>
    <div class="secondLine"> {{'TEXT.IN_PROMISE' | translate}}</div>

    <button type="button" class="command-button createRouletteButtonNow"
      (click)="scrollTo('prices')">{{'ROULETTE.CREATE_ROULETTE_NOW' | translate}}</button>
     <!-- <div class="firstLine">{{'TEXT.MANY_BUSINESS' | translate}}</div> -->
  </div>
  <!-- <div class="divBtn">
            <button pButton pRipple type="button" label="{{'ROULETTE.CREATE_ROULETTE_NOW' | translate}}"
                class="p-button-text createRouletteButtonNow" (click)="createRoulette()"></button>
        </div> -->
</div>

<div class="section_title_bg"><span class="content_title">{{'LANDING_PAGE.SECTION_2_TITTLE' | translate}}</span>
</div>
<div class="section_content">
  <span id="content_1"  [innerHTML]="'LANDING_PAGE.SECTION_2_CONTENT_PART1' | translate"></span>
  <span id="content_2"  [innerHTML]="'LANDING_PAGE.SECTION_2_CONTENT_PART2' | translate"></span>
  <span id="content_3" [innerHTML]="'LANDING_PAGE.SECTION_2_CONTENT_PART3' | translate"></span>
</div>
<!-- video -->
<div class="border_video">
  <video controls (click)="toggleVideo()" muted autoplay oncanplay="this.play()" onloadedmetadata="this.muted = true"  #videoPlayer class="video">
    <source
    src="https://stwstorageaccount.blob.core.windows.net/videospintowin/SpinToWinVideoEn.mp4"
          type="video/mp4" />
  </video>
  <img *ngIf="!isPlay" class="playImage" src="assets/images/play-icon.svg" (click)="toggleVideo()">
</div>


 <!-- Inectives  -->
<section id="solutions">
  <app-reasons-for-using-our-product></app-reasons-for-using-our-product>
</section>
<!-- what is spinToWin?? -->

<!-- What Sets Spin to Win Apart? -->
<div class="section_title_bg"><span class="content_title">{{'LANDING_PAGE.SET_APART' | translate}}</span></div>
<app-display-cards [cardData]="cardsSetsApart"></app-display-cards>
<!-- why choose spin to win  -->
  <div class="section_title_bg"><span class="content_title">{{'LANDING_PAGE.WHY_CHOOSE_US' | translate}}</span></div>
  <app-display-cards [cardData]="cardsReasonsToChooseUs"></app-display-cards>
<!-- About Us -->
 <section id="aboutUs">
 <app-about-us> </app-about-us>
</section>



<!-- without prev/next -->

<!-- how it work  -->
<section id="howItWork">
  <div class="section_title_bg"><span class="content_title">{{'LANDING_PAGE.HOW_IT_WORKS' | translate}}</span></div>
  <app-display-cards [cardData]="cardsHowItWork"></app-display-cards>
</section> 
<!-- video2 instruction-->
<div class="border_video">
  <video controls (click)="toggleVideo2()" muted autoplay oncanplay="this.play2()" onloadedmetadata="this.muted = true"  #videoPlayer2 class="video">
    <source
    src="https://stwstorageaccount.blob.core.windows.net/videospintowin/spintowin.mp4"
          type="video/mp4" />
  </video>
  <img *ngIf="!isPlay" class="playImage" src="assets/images/play-icon.svg" (click)="toggleVideo2()">
</div>
<div class="section_title_bg"> <span class="content_title">{{'LANDING_PAGE.HOW_IT_WORKS_FOOTER'|translate}}</span></div> 

<!-- customer telling -->
 <app-customers-telling [startFromSecond]="false"></app-customers-telling>
 <!-- <app-customer-telling></app-customer-telling> -->
 <!-- questions -->
<section id="commonQuestions">
  <div class="section_title_bg"><span class="content_title">{{'LANDING_PAGE.COMMON_QUESTIONS' | translate}}</span>
  </div>
  <app-questions></app-questions>
</section>

<div class="section_title_bg">
  <span class="content_title">{{'LANDING_PAGE.CONTENT_CHOOSE' | translate}}</span>
</div>
<!-- subscriptions -->
<section id="prices">
 <span class="content_title">{{'LANDING_PAGE.PRICES' | translate}}</span>
  <app-roulette-subscribtion [IsViewMode]="true"></app-roulette-subscribtion>
</section>
<div class="section_title_bg"><span class="content_title">{{'LANDING_PAGE.START_GROW' | translate}}</span></div>
<section id="customers-tell">
  <app-customers-telling [startFromSecond]="true"></app-customers-telling>
</section>

<div class="form-divider mobile"></div>
<!-- footer -->
<div class="footer">
  <div class="row section1" style="align-items: center;">
    <div class="logo">
      <img src="assets/images/logo.svg" style="width: 135px; height: 97px;">
    </div>
    <div>
      <div>+972-58-700-2323 </div>
      <div>info&#64;spintuwin.com</div>
      <div>{{'LANDING_PAGE.ADDRESS' | translate}}</div>
    </div>
  </div>
  <div class="column section2">
    <div>
      <a  (click)="scrollTo('aboutUs')" >{{'LANDING_PAGE.ABOUT_US' | translate}}</a>
    </div>
    <div>
      <a [href]="getAbsoluteUrl('/termsOfUse', language)" target="_blank"
        rel="noopener noreferrer">
        {{ 'LANDING_PAGE.TERMS_OF_USE' | translate }}
      </a>
    </div>
    <div>
      <a [href]="getAbsoluteUrl('/privacyPolicy', language)" target="_blank"
        rel="noopener noreferrer">
        {{ 'LANDING_PAGE.PRIVACY_POLICY' | translate }}
      </a>
    </div>
    <div>
      <a [href]="getAbsoluteUrl('/RefundCancellationPolicy', language)" target="_blank"
        rel="noopener noreferrer">
        {{ 'LANDING_PAGE.CANCELETION_POLICIES' | translate }}
      </a>
    </div>
  </div>
  <!-- <div class="icons">
    <img src="assets/images/icons/Icon awesome-youtube.svg" class="icon" />
    <img src="assets/images/icons/Icon metro-facebook.svg" class="icon" />
  </div> -->
</div>